import { render, staticRenderFns } from "./Facturation.vue?vue&type=template&id=3a571338"
import script from "./Facturation.vue?vue&type=script&lang=js"
export * from "./Facturation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports